import { render } from "./BottomBarMenuModal.vue?vue&type=template&id=56a99543"
import script from "./BottomBarMenuModal.vue?vue&type=script&lang=js"
export * from "./BottomBarMenuModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__